import React from "react";
import { initializeIcons } from "@uifabric/icons";
import { IIconProps, Spinner, SpinnerSize } from "office-ui-fabric-react";

import { EventEmitter } from "./events";

import SplitterLayout from "react-splitter-layout";
import "react-splitter-layout/lib/index.css";

import Logo from "./logo";
import Profile from "./profile-section";
import Search from "./search";
import Waffle from "./waffle-menu";
// import SearchBox from "./searchbox"

import MatterView from "./matterview";
import SimpleView from "./simpleview";

import "../styles/homepage.css";
import CaselyLogo from "../images/caselyLogo.png";
import Axios from "axios";

initializeIcons();

interface IState {
  isLoaded: boolean;
  token: string;
  name: string;
  image: string;
  userName: string;
  userId: string;
  firstName: string;
  originalURL: string;
  items: any[];
  searchLabel: string;
  searchText: string;
  matterURL: string;
  globalsearchURL: string;
  formActionURL: string;
  formTarget: string;
  blocking: boolean;
  sidebarOpen: boolean;
  userView: string;
  workFlowURL: string;
  getUserSettingURL: string;
  setUserSettingURL: string;
}

const queryString = ((a) => {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
})(window.location.search.substr(1).split('&'));

export default class HomePage extends React.Component<{}, IState> {
  constructor(props: {}) {
    super(props);

    EventEmitter.subscribe("save-ui", () => {
      this.setUserView();
    });

    this.state = {
      isLoaded: false,
      token: "",
      name: "",
      image: "",
      userName: "",
      firstName: "",
      userId: "",
      originalURL: "",
      items: [],
      searchLabel: "Search",
      searchText: "",
      matterURL: "",
      globalsearchURL: "",
      formActionURL: "",
      formTarget: "",
      blocking: false,
      sidebarOpen: true,
      userView: "simple",
      workFlowURL: "",
      getUserSettingURL: "",
        setUserSettingURL: "",
        hasv1Access: queryString['hv1'],
        hasv2Access: queryString['hv2']
    };

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  onSetSidebarOpen(open: boolean) {
    this.setState({ sidebarOpen: open });
  }

  getUserSession = () => {
    // Get current user name

    let userSession = JSON.parse(localStorage.getItem("userSession"));
    let fullname = userSession.name;
    let spaceIndex = fullname.indexOf(" ");
    let firstname = fullname;
    if (spaceIndex > 0) {
      firstname = fullname.substring(0, spaceIndex);
    }

    // Get API URL
    let apiURL = JSON.parse(localStorage.getItem("api"));

    // //
    let userUi = localStorage.getItem("user-ui");

    this.setState(
      {
        userName: userSession.userName,
        firstName: firstname,
        matterURL: apiURL.matterdetail,
        globalsearchURL: apiURL.globalsearch,
        workFlowURL: apiURL.workflowtaskUrl,
        getUserSettingURL: apiURL.getUserSettingURL,
        setUserSettingURL: apiURL.setUserSettingURL,
      },
      () => {
        this.getUserSetting().then((res) => {
          if (res === "") {
            this.setUserSetting().then(() => {
              if (res === "" || userUi === undefined || userUi === null) {
                userUi = "simple";
              }
              this.setState({
                userView: userUi,
                isLoaded: true,
              });
            });
          } else {
            this.setState({
              userView: res,
              isLoaded: true,
            });
          }
          localStorage.setItem("user-ui", res);
        });
      },
    );
  };

  loadParent = () => {
    this.setState({
      blocking: true,
    });
  };

  setUserView() {
    let userUi = localStorage.getItem("user-ui");
    if (userUi !== null) {
      this.setState(
        {
          userView: userUi,
        },
        () => {
          this.setUserSetting().then(() => {
            this.setState({
              userView: userUi,
              isLoaded: true,
            });
          });
        },
      );
    }
  }

  getUserSetting() {
    var url =
      this.state.getUserSettingURL +
      "&key=user-ui&email=" +
      this.state.userName;
    // return fetch(url, {
    //   method: "get"
    // }).then(res => res.text());

    return Axios.get(url).then((res) => res.data);
  }

  setUserSetting() {
    var url = this.state.setUserSettingURL;
    const param = {
      email: this.state.userName,
      key: "user-ui",
      value: this.state.userView,
    };

    // return fetch(url, {
    //   method: "post",
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify(param)
    // }).then(res => res.text());
    return Axios.post(url, JSON.stringify(param)).then((res) => res.data);
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("load-trigger", this.getUserSession);
    }

    if (window.location.href === "http://localhost:8080/") {
      this.getUserSession();
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("load-trigger", this.getUserSession);
    }
  }

  public render() {
    const centerText = {
      textAlign: "center",
    };

    const rightText = {
      textAlign: "right",
    };
    const { isLoaded } = this.state;
    if (!isLoaded) return <div>Loading...</div>;
    else {
      return (
        <div className="ms-Grid Main-Wrapper" dir="ltr">
          {this.state.blocking === true ? (
            <Spinner
              className="spinner"
              size={SpinnerSize.large}
              label="Loading..."
              ariaLive="assertive"
              labelPosition="top"
            />
          ) : (
            ""
          )}
          <div className="ms-Grid-row header-wrapper">
            <div className="ms-Grid-col ms-sm6 ms-md4 ms-lg2 casely-logo">
              <div>
                <Logo></Logo>
              </div>
            </div>
            <div
              className="ms-Grid-col ms-sm6 ms-md4 ms-lg8"
              style={centerText}
            >
            {(this.state.hasv2Access != null &&
            this.state.hasv2Access == "true" &&
            this.state.userView != null &&
            this.state.userView != undefined &&
            this.state.userView != "" &&
            this.state.userView === "advance") || (
            this.state.hasv2Access != null &&
            this.state.hasv2Access == "true" &&
            (this.state.hasv1Access == null || this.state.hasv1Access == "false")) ? (
                <div className="header-item">
                    <Search parentLoading={this.loadParent}></Search>
                    {/* <SearchBox searchText={this.state.searchText} /> */}
                </div>
              ) : null}
            </div>
            <div
              className="ms-Grid-col ms-sm6 ms-md4 ms-lg2 profile-pic"
              style={rightText}
            >
              <div className="header-item">
                          <Profile userView={this.state.userView}></Profile>
                          <Waffle/>
              </div>
            </div>
          </div>
            <div className="ms-Grid-row content-wrapper">
                {
                    this.state.hasv2Access != null &&
                    this.state.hasv2Access == "true" &&
                    this.state.userView != null &&
                    this.state.userView != undefined && 
                    this.state.userView != "" && 
                    this.state.userView === "advance" ? 
                            <MatterView workFlowURL={this.state.workFlowURL}></MatterView> : 
                    this.state.hasv2Access != null &&
                    this.state.hasv2Access == "true" &&
                    (this.state.hasv1Access == null || this.state.hasv1Access == "false") ? 
                        <MatterView workFlowURL={this.state.workFlowURL}></MatterView> : 
                    <SimpleView></SimpleView>
                }
          </div>
        </div>
      );
    }
  }
}
